import * as tslib_1 from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
import TipModal from './newUserTipModal.vue';
import shareDiv from '../shareDiv.vue';
import showDiv from '@ivy/fts/showDiv';
import { env } from '@ivy/fts/envInfo/envInfo';
import CouponListPopup from '../../comps/couponListPopup.vue';
const success = {
    text: '拼团成功',
    html: `可在常青藤爸爸APP/常青藤爸爸服务号"我的订单"中查看`,
};
const fail = {
    text: '拼团失败！',
    html: `拼团失败，退款将在15个工作日内原路返还`,
};
let SepllRow = class SepllRow extends Vue {
    constructor() {
        super(...arguments);
        this.pinStatus = { success, fail };
        this.timeText = '';
        this.setTimeoutId = null;
        this.coupons = [];
    }
    get payAmount() {
        return (this.groupDetail.sku.goods_price - +this.groupDetail.discount).toFixed(2);
    }
    get defaultAvatarNum() {
        return Math.max(this.groupDetail.group_num - this.groupDetail.followers.length, 0);
    }
    created() {
        if (this.groupDetail.status === 'paying') {
            return this.toCourseDetail();
        }
        else if (this.groupDetail.status === 'wait_to_fail') {
            this.groupDetail.status = 'fail';
        }
        let ms = Date.newDate(this.groupDetail.end_time).getTime() - new Date().getTime();
        this.countdown(ms);
        this.getProcessingCoupons();
    }
    async showCurrentCoupons() {
        await showDiv(CouponListPopup, {
            visible: true,
            mode: 'acquire',
            product: {
                thresholdPrice: this.payAmount,
                type: this.groupDetail.product_type,
                course_id: this.groupDetail.product_id,
                spuId: this.groupDetail.sku.spu_id,
            },
        });
    }
    async getProcessingCoupons() {
        let url = `/api/goods/shop/search/coupon/getProcessingCouponByGoods`;
        let { data } = await this.$axios.get(url, {
            params: {
                limit: 10,
                spuId: this.groupDetail.sku.spu_id,
            },
        });
        if (!data.length) {
            return;
        }
        this.coupons = data;
    }
    countdown(msec) {
        // 相差的毫秒数
        if (msec <= 0) {
            this.timeText = '00:00:00';
            return window.clearTimeout(this.setTimeoutId);
        }
        this.timeText = Date.formatMs(msec, msec / (24 * 60 * 60 * 1000) > 1 ? 'DD天 hh:mm:ss' : 'hh:mm:ss');
        // 一秒后递归
        this.setTimeoutId = setTimeout(() => {
            this.countdown(msec - 1000);
        }, 1000);
    }
    beforeDestory() {
        window.clearTimeout(this.setTimeoutId);
    }
    toGoodsView() {
        let _cookieRegister = this.$route.query._cookieRegister;
        this.$router.push({
            path: `goodsView`,
            query: {
                spuId: this.groupDetail.sku.spu_id,
                type: this.groupDetail.sku.goods_type,
                _cookieRegister,
            },
        });
    }
    toCourseDetail() {
        // 忽略原逻辑，直接跳回现商品展示页
        if (this.groupDetail.status === 'success' ||
            this.groupDetail.status === 'fail') {
            // let origin = process.env.NODE_ENV === 'production' ? 'https://m.ivydad.com' : 'http://m.ivydad.com.cn'
            // window.location.href = `${origin}/center/order/orderList`
            return this.$router.push({
                path: `orderDetail`,
                query: {
                    tid: this.groupDetail.my_group.tid,
                },
            });
        }
        // if (this.groupDetail.status === 'fail') {
        //   console.log(this.groupDetail.tid)
        //   return this.$router.push({
        //     path: `orderDetail`,
        //     query: {
        //       tid: this.groupDetail.tid
        //     }
        //   })
        // }
        // if (
        //   this.groupDetail.status === 'success' &&
        //   this.groupDetail.qrcode &&
        //   this.groupDetail.joined
        // ) {
        //   return showDiv(TipModal, {
        //     title: '课程上线APP啦，快去APP上课吧',
        //     remark:
        //       ' 可在常青藤爸爸APP"我的-已购买的"中查看，还有更多优质启蒙资源等你来。',
        //     clickText: '去APP',
        //     clickButton: () => openApp()
        //   })
        // }
        // if (this.groupDetail.product_type === 'knowlege') {
        //   window.location.href = `${window.location.origin}/knowlege/channelDetail?id=${this.groupDetail.product_id}`
        // } else if (this.groupDetail.product_type === 'course') {
        //   let { spuId, type } = this.$route.query
        //   this.$router.push({
        //     path: `goodsView`,
        //     query: {
        //       spuId,
        //       type
        //     }
        //   })
        // } else {
        //   return showDiv(TipModal, {
        //     title: '课程上线APP啦，快去APP上课吧',
        //     remark: '还有更多优质启蒙资源等你来',
        //     clickText: '去APP',
        //     clickButton: () => openApp()
        //   })
        // }
    }
    clickGroupShare() {
        if (!this.groupDetail || !this.groupDetail.id) {
            return;
        }
        showDiv(shareDiv);
    }
    async clickGroupJoin() {
        if (!this.groupDetail || !this.groupDetail.id) {
            return;
        }
        // 截止时间 晚于当前时间
        if (Date.newDate(this.groupDetail.end_time).getTime() < new Date().getTime()) {
            return this.$Toast('拼团活动结束啦');
        }
        // 进行校验
        let { data } = await this.$axios.get(`/api/goods/shop/market/group/verifyGroup`, {
            params: { activity_id: this.groupDetail.activity_id },
        });
        if (!data.can_join) {
            if (data.reason === 'not_new_user') {
                return showDiv(TipModal, {
                    title: '参团条件：新用户参团',
                    remark: '该商品为新用户专享，您可以点击【去开团】，支付成功后邀请好友一起拼团',
                    clickText: '去开团',
                    clickButton: this.toGoodsView,
                });
            }
            return this.$Toast(data.message || '您已经参与了拼团，不可以重复购买');
        }
        const activity = {
            group: {
                organizerId: this.organizerId,
            },
        };
        let { spuId } = this.$route.query;
        if (this.isApp) {
            let confirmInfo = {
                skuId: this.groupDetail.sku.goods_id,
                type: this.groupDetail.product_type,
                from: 'new-group-view',
                isGroup: true,
                activityType: 'group',
            };
            let groupParamsInfo = {
                groupActivityId: this.groupDetail.activity_id,
                groupLeaderId: this.groupDetail.group_order_id,
                groupType: 'join',
            };
            let info = {
                path: 'pages/new-goods-confirm/index.js',
                confirmInfo: confirmInfo,
                groupParamsInfo: groupParamsInfo,
            };
            await env.openGoodsConfirm(info);
        }
        else {
            this.$router.push({
                path: '/orderConfirm',
                query: {
                    spuId,
                    skuId: this.groupDetail.sku.goods_id,
                    isGroup: '1',
                    type: this.groupDetail.product_type,
                    group_order_id: this.groupDetail.group_order_id,
                },
            });
        }
    }
};
tslib_1.__decorate([
    Prop()
], SepllRow.prototype, "isApp", void 0);
tslib_1.__decorate([
    Prop({ default: {} })
], SepllRow.prototype, "groupDetail", void 0);
tslib_1.__decorate([
    Prop({ default: 0 })
], SepllRow.prototype, "organizerId", void 0);
SepllRow = tslib_1.__decorate([
    Component
], SepllRow);
export default SepllRow;
